
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/volunteer-policy",
      function () {
        return require("private-next-pages/about/volunteer-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/volunteer-policy"])
      });
    }
  